import ReactConfetti from 'react-confetti';

type SurveyCompleteViewProps = {
  showConfetti: boolean;
  windowDimensions: { width: number; height: number };
  questionCount: number;
};

export function SurveyCompleteView({
  showConfetti,
  windowDimensions,
  questionCount,
}: SurveyCompleteViewProps) {
  return (
    <div className="flex-1 flex items-center justify-center px-6 py-12 text-center">
      {showConfetti && (
        <ReactConfetti
          width={windowDimensions.width}
          height={windowDimensions.height}
          recycle={false}
          numberOfPieces={450}
          gravity={0.12}
        />
      )}
      <div className="flex max-w-[460px] flex-col items-center">
        <div className="relative mb-7 grid h-32 w-32 place-items-center rounded-full bg-gradient-to-br from-[var(--retailer-success)] to-green-400 shadow-[0_16px_48px_rgba(22,163,74,0.35)] before:absolute before:inset-[-14px] before:rounded-full before:border-2 before:border-[var(--retailer-success)] before:opacity-25 after:absolute after:inset-[-28px] after:rounded-full after:border-2 after:border-[var(--retailer-success)] after:opacity-10">
          <svg
            className="relative z-10 h-16 w-16 text-white"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <p className="font-mono text-xs font-medium uppercase tracking-[0.18em] text-[var(--retailer-success)] mb-3">
          All done
        </p>
        <h1 className="font-display text-[clamp(36px,7vw,56px)] font-extrabold leading-[1.05] tracking-[-0.03em] text-ink mb-4">
          Thank you!
        </h1>
        <p className="text-[16px] leading-[1.6] text-ink-muted mb-6 max-w-[400px]">
          Thanks for sharing — your answers will help brands build products that
          actually fit your routine.
        </p>
        <div className="inline-flex items-center gap-2 rounded-full bg-[var(--retailer-success-pale)] px-5 py-2.5 text-sm font-semibold text-[var(--retailer-success)]">
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M5 13l4 4L19 7"
            />
          </svg>
          Survey complete · {questionCount} of {questionCount} answered
        </div>
      </div>
    </div>
  );
}
